export function getDaysDifference(date1: string, date2: string) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const diffTime = d2.getTime() - d1.getTime(); // difference in milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // convert to days

  return diffDays;
}